var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TagMultiSelect,_vm._g(_vm._b({scopedSlots:_vm._u([{key:"open-indicator",fn:function({ attributes }){return [_c(_setup.SelectBoxChevronDown,_vm._b({},'SelectBoxChevronDown',attributes,false))]}}])},'TagMultiSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }